const isDev = process.env.NODE_ENV === 'development';

const CONFIG = {
  aid: 'apitjj20230515',
  asec: 'd06b4fe78673dd5e37a0a9b557485593',
  domain: isDev ? '//tjj.eyurl.cn/' : '',
  devCdn: isDev ? '//tjj.eyurl.cn/' : '',
};

export default CONFIG;
